import React, { useEffect, useState } from "react";
import { enviarComando } from "../services/comandoService.js"; // ✅ Importa si deseas reenviar

const WebSocketStatus = ({ equipoHash, ip, agregarHistorial }) => {
  const [estado, setEstado] = useState("🔴 Desconectado");
  const [color, setColor] = useState("text-gray-600");
  const [mensaje, setMensaje] = useState("");
  const [conectado, setConectado] = useState(false);
  const [ws, setWs] = useState(null);

  const urlBase = "wss://dev.dimalink.cl/ws";

  // 🔄 Reconecta automáticamente cuando cambia equipoHash
  useEffect(() => {
    conectarWebSocket();

    return () => {
      desconectarWebSocket();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipoHash]);

  const conectarWebSocket = () => {
    if (!equipoHash) return;

    desconectarWebSocket(); // 🔴 Cierra si hay uno abierto

    const url = `${urlBase}?hash=${equipoHash}`;
    const socket = new WebSocket(url);

    socket.onopen = () => {
      setEstado("🟢 Conectado");
      setColor("text-green-600");
      setConectado(true);
      agregarHistorial(`🟢 Conectado a WS [${equipoHash}]`);
    };

    socket.onclose = () => {
      setEstado("🔴 Desconectado");
      setColor("text-gray-600");
      setConectado(false);
      agregarHistorial(`🔴 Desconectado WS [${equipoHash}]`);
    };

    socket.onerror = (e) => {
      console.error("❌ WebSocket error", e);
      setEstado("⚠️ Error");
      setColor("text-red-600");
      agregarHistorial(`❌ Error WS [${equipoHash}]: ${e.message}`);
    };

    socket.onmessage = async (event) => {
      const recibido = event.data;
      agregarHistorial(`📥 WS [${equipoHash}]: ${recibido}`);

      // ✅ Reenvía a IP configurada si existe
      if (ip) {
        try {
          const respuesta = await enviarComando(ip, recibido);
          agregarHistorial(`✅ Reenviado a ${ip}: ${respuesta}`);
        } catch (error) {
          console.error(`❌ Error al enviar a ${ip}:`, error);
          agregarHistorial(`❌ Error al enviar a ${ip}: ${error.message}`);
        }
      } else {
        agregarHistorial(`⚠️ IP no configurada para reenvío.`);
      }
    };

    setWs(socket);
  };

  const desconectarWebSocket = () => {
    if (ws) {
      ws.close();
      setWs(null);
    }
  };

  const enviarMensaje = () => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(mensaje);
      agregarHistorial(`➡️ Enviado: ${mensaje}`);
      setMensaje("");
    }
  };

  return (
    <div className="bg-white shadow-lg border border-gray-300 rounded-xl p-4 w-full">
      <p className={`font-semibold ${color}`}>Estado WebSocket: {estado}</p>

      <div className="flex gap-2 mt-3">
        <button
          onClick={conectarWebSocket}
          className="flex-1 bg-green-600 text-white text-sm px-3 py-1 rounded hover:bg-green-700 disabled:opacity-50"
          disabled={conectado}
        >
          Conectar
        </button>
        <button
          onClick={desconectarWebSocket}
          className="flex-1 bg-red-600 text-white text-sm px-3 py-1 rounded hover:bg-red-700 disabled:opacity-50"
          disabled={!conectado}
        >
          Desconectar
        </button>
      </div>

      <div className="flex mt-3 gap-2">
        <input
          type="text"
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          className="flex-1 text-sm border rounded px-2 py-1"
          placeholder="Escribe un mensaje..."
          disabled={!conectado}
        />
        <button
          onClick={enviarMensaje}
          className="bg-blue-600 text-white text-sm px-3 py-1 rounded hover:bg-blue-700 disabled:opacity-50"
          disabled={!conectado}
        >
          Enviar
        </button>
      </div>
    </div>
  );
};

export default WebSocketStatus;
